import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {columnStackableMobile} from '../../../styles/js/mixins/layout';
import {colours, fonts, spacing} from '../../../styles/js/variables';

const styles = {
  businessStatsItem: css`
    label: businessStatsItem;
    ${columnStackableMobile(spacing.M)}
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 2.5rem;
    color: ${colours.font.BLACK};
    text-align: center;

    ${mq(Breakpoints.TABLET)} {
      flex: 1 0 20rem;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  `,
  icon: css`
    label: businessStatsItem__icon;
    height: 4.9rem;
  `,
  stat: css`
    label: businessStatsItem__stat;
    position: relative;
    margin: 0 0 ${spacing.XXS};
    font-weight: ${fonts.weight.SEMI_BOLD};
    font-size: 4rem;
    line-height: 1.3;

    &::after {
      position: absolute;
      top: 100%;
      left: 50%;
      width: 4.5rem;
      height: 0;
      border-bottom: 3px solid rgba(${colours.general.WHITE}, 0.3);
      transform: translateX(-50%);
      content: '';
    }
  `,
  desc: css`
    label: businessStatsItem__desc;
    margin: 0;
  `,
};

export default styles;
